import { render } from "./ModulesSelector.vue?vue&type=template&id=06a8e3c3"
import script from "./ModulesSelector.vue?vue&type=script&lang=js"
export * from "./ModulesSelector.vue?vue&type=script&lang=js"
script.render = render

export default script